import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LotsComponent } from './pages/lots/lots.component';
import { CreateLotComponent } from './pages/create-lot/create-lot.component';
import { StockEntryComponent } from './stock-entry.component';
import { AuthGuard } from '@app/shared/auth/auth.guard';
import { CreateBagComponent } from './pages/create-bag/create-bag.component';
import { ReceivingWaybillComponent } from './pages/receiving-waybill/receiving-waybill.component';
import { BatchDeliveryComponent } from './pages/batch-delivery/batch-delivery.component';
import { Charging } from './pages/charging/charging.component';

const routes: Routes = [
  { path: '', component: StockEntryComponent, canActivate: [AuthGuard] },
  { path: 'lotes', component: LotsComponent, canActivate: [AuthGuard] },
  { path: 'criar', component: CreateLotComponent, canActivate: [AuthGuard] },
  { path: 'criar-saca', component: CreateBagComponent, canActivate: [AuthGuard] },
  { path: 'receber', component: ReceivingWaybillComponent, canActivate: [AuthGuard] },
  { path: 'entregar-lotes', component: BatchDeliveryComponent, canActivate: [AuthGuard] },
  { path: 'carregamento', component: Charging, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StockEntryRoutingModule {}
